// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__hJo3A","ranges":"BmiRanges_ranges__12mWs"};